import * as React from "react"
import { cn } from "./utils"

type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>

function Label({ className, ...props }: LabelProps) {
    return (
        <label
            data-slot="label"
            className={cn(
                "flex items-center gap-2 calculator-text font-light leading-none select-none \
         peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
                className
            )}
            {...props}
        />
    )
}

export { Label }
